function hasValue(val: unknown): boolean {
  if (val === null || val === undefined) return false
  if (Array.isArray(val)) return val.length > 0
  if (typeof val === "object") return Object.keys(val).length > 0
  if (typeof val === "string") return val.trim().length > 0
  return true
}

type MergeOptions<T, U> = {
  base: "first" | "second"
  mergeExtra?: boolean
}

function mergeObjects<T extends object, U extends object>(
  obj1: T,
  obj2: U,
  options: MergeOptions<T, U> & { mergeExtra: true }
): T & U

function mergeObjects<T extends object, U extends object>(
  obj1: T,
  obj2: U,
  options: MergeOptions<T, U> & { mergeExtra?: false }
): T

function mergeObjects<T extends object, U extends object>(
  obj1: T,
  obj2: U,
  options: MergeOptions<T, U>
): T | (T & U) {
  const base = (options.base === "first" ? obj1 : obj2) as T & U
  const other = (options.base === "first" ? obj2 : obj1) as T & U

  const result = (Object.keys(base) as Array<keyof (T & U)>).reduce(
    (acc, key) => {
      const otherVal = other[key]
      const baseVal = base[key]

      acc[key] = hasValue(otherVal) ? otherVal : baseVal
      return acc
    },
    {} as T & U
  )

  if (options.mergeExtra) {
    ;(Object.keys(other) as Array<keyof (T & U)>).forEach((key) => {
      if (!(key in base)) {
        result[key] = other[key]
      }
    })
  }

  return result
}

export default mergeObjects
